<template>
    <div class="pointer-events-none absolute inset-x-5 bottom-5 overflow-clip">
        <div
            class="flex gap-1.5 transition duration-500 ease-out"
            :class="{
                'opacity-0': !disabled && !props.loading,
            }"
        >
            <div
                v-for="item in 96"
                :key="item"
                class="flex h-14 min-w-[8px] origin-bottom rounded-t-full transition duration-300 will-change-transform"
                :class="[
                    item % 7 ? (item % 3 ? 'translate-y-8' : 'translate-y-4') : '',
                    props.loading ? 'bg-sky-200' : 'bg-slate-200',
                    props.loading && 'motion-safe:animate-[pulse_1.3s_infinite]',
                    !disabled && !props.loading && 'translate-y-full!',
                ]"
                :style="item % 7 ? (item % 5 ? 'animation-delay: 0s' : 'animation-delay: .2s') : 'animation-delay: .4s'"
            />
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    loading: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});
</script>
